import { createMuiTheme } from '@material-ui/core/styles'
import merge from 'lodash/merge'

export function createOrderToCashTheme (theme) {
  const border = `1px solid ${theme.palette.divider}`
  const mobile = theme.breakpoints.down('xs')
  const overrides = {
    MuiContainer: {
      maxWidthLg: { [theme.breakpoints.up('lg')]: { maxWidth: 1450 } },
      maxWidthXl: { [theme.breakpoints.up('lg')]: { maxWidth: 1450 } }
    },
    MuiCard: {
      root: {
        border,
        borderRadius: 16,
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.055)',
        minWidth: 0
      }
    },
    MuiCardHeader: {
      root: {
        minHeight: 60,
        padding: theme.spacing(2, 3),
        gap: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: { flexWrap: 'wrap' },
        [mobile]: { padding: theme.spacing(2) }
      },
      content: { minWidth: 0 },
      action: {
        margin: 0,
        alignSelf: 'center',
        maxWidth: '100%',
        [theme.breakpoints.down('sm')]: { flexBasis: '100%' }
      },
      title: { fontSize: 18, fontWeight: 600, lineHeight: 1.4 }
    },
    MuiCardContent: {
      root: {
        padding: theme.spacing(3),
        [mobile]: { padding: theme.spacing(2) }
      }
    },
    MuiCardActions: {
      root: {
        borderTop: border,
        minHeight: 56,
        padding: theme.spacing(1.5, 3),
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        [mobile]: { padding: theme.spacing(1.5, 2) }
      }
    },
    MuiButton: {
      root: { borderRadius: 10, minHeight: 40, textTransform: 'none' },
      contained: { boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)' },
      containedPrimary: { boxShadow: '0 6px 14px rgba(191, 30, 45, 0.14)' }
    },
    MuiButtonGroup: {
      root: {
        boxShadow: 'none',
        maxWidth: '100%',
        [mobile]: {
          flexDirection: 'column',
          alignItems: 'stretch',
          '& .MuiButtonGroup-grouped': { borderRadius: 10, margin: theme.spacing(0.5, 0), border }
        }
      }
    },
    MuiOutlinedInput: { root: { borderRadius: 10 } },
    MuiFormHelperText: {
      root: { marginTop: theme.spacing(1), marginBottom: theme.spacing(0.5), lineHeight: 1.45 }
    },
    MuiTableCell: {
      root: { padding: theme.spacing(1.5, 2), fontVariantNumeric: 'tabular-nums' },
      head: { backgroundColor: '#F8FAFC', color: theme.palette.text.secondary, fontSize: 11, fontWeight: 700 },
      stickyHeader: { backgroundColor: '#F8FAFC' }
    },
    MuiTablePagination: {
      root: { borderTop: border },
      toolbar: { minHeight: 56, flexWrap: 'wrap', padding: theme.spacing(0.5, 2) },
      spacer: { [mobile]: { display: 'none' } }
    },
    MuiTabs: { root: { borderBottom: border, backgroundColor: '#F8FAFC' } },
    MuiTab: { root: { textTransform: 'none', fontWeight: 600 } },
    MuiStepper: { root: { padding: theme.spacing(3, 0, 4) } },
    MuiDialog: {
      paper: { borderRadius: 18, boxShadow: '0 14px 36px rgba(15, 23, 42, 0.12)' },
      paperScrollPaper: { [mobile]: { margin: theme.spacing(2), maxWidth: 'calc(100% - 32px)' } },
      paperFullWidth: { [mobile]: { width: 'calc(100% - 32px)' } }
    },
    MuiDialogTitle: { root: { padding: theme.spacing(2.5, 3), borderBottom: border } },
    MuiDialogContent: { root: { padding: theme.spacing(3), '&:first-child': { paddingTop: theme.spacing(3) } } },
    MuiDialogActions: {
      root: { padding: theme.spacing(2, 3), borderTop: border, flexWrap: 'wrap', gap: theme.spacing(1) }
    },
    MuiDrawer: { paperAnchorRight: { borderLeft: border, boxShadow: '-8px 0 24px rgba(15, 23, 42, 0.06)' } }
  }

  // Merge into a new object so shared components keep the parent theme on other routes.
  return createMuiTheme({ ...theme, overrides: merge({}, theme.overrides, overrides) })
}
